module.exports = {
      id: "gift-pink-usage",
      viewBox: "0 0 110 113",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#gift-pink",
      toString: function () {
        return this.url;
      }
    }